import type { Row } from '../constants';

import type { Cache } from './ContentCache';

import { normarliseCacheData } from './normarliseCacheData';
import { getRowValidationError } from './getRowValidationError';

export const validateCache = (
  cache: Cache
): {
  populatedRows: [number, Row][];
  invalidRows: [number, Row][];
  error: string | null;
  errorRowRanges: number[][];
} => {
  const rows = normarliseCacheData(cache);
  const populatedRows: [number, Row][] = [];

  for (let i = 0; i < rows.length; i++) {
    if (Object.values(rows[i]).every((value) => value === null)) {
      continue;
    }
    populatedRows.push([i, rows[i]]);
  }

  const invalidRows = populatedRows.filter(([_, row]) => {
    return Object.values(row).some((value) => value === null);
  });

  if (invalidRows.length > 0) {
    const userReadableInvalidRowIndexes = invalidRows.map(
      ([rowIndex]) => rowIndex + 1
    );

    const { message = '', errorRowRanges = [] } =
      getRowValidationError(userReadableInvalidRowIndexes) ?? {};

    return { populatedRows, invalidRows, error: message, errorRowRanges };
  }

  return { populatedRows, invalidRows, error: null, errorRowRanges: [] };
};
